var _rect, _rect2, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayUserLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 97,
    viewBox: "0 0 112 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.9688,
    y: 16.4751,
    width: 20.6314,
    height: 14.879,
    rx: 2,
    transform: "rotate(-30.018 55.9688 16.4751)",
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.0342,
    y: 0.839844,
    width: 20.6314,
    height: 14.879,
    rx: 2,
    transform: "rotate(52.5921 55.0342 0.839844)",
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4879 50.7001C71.1127 51.7389 71.6544 52.8747 72.6979 53.2368L93.1329 60.3287L91.9931 63.8444C90.8267 67.4421 92.8086 71.2699 96.4198 72.394L97.0654 72.5949C100.757 73.7439 104.716 71.6941 105.908 68.0166L107.328 63.6348C107.414 63.5051 107.485 63.3637 107.54 63.2117L110.596 54.7514C110.971 53.7125 110.43 52.5767 109.386 52.2146L77.1127 41.0144C76.0692 40.6522 74.9191 41.2008 74.5438 42.2397L71.4879 50.7001Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2186 57.6749C41.5776 58.7195 41.0182 59.8467 39.9691 60.1925L19.4258 66.9642L20.5106 70.4973C21.6206 74.1128 19.5791 77.9092 15.9508 78.9767L15.3022 79.1676C11.5934 80.2588 7.66695 78.1474 6.53228 74.4516L5.18034 70.0482C5.09709 69.9173 5.02785 69.7747 4.97534 69.6219L2.05194 61.1148C1.69297 60.0702 2.25238 58.9431 3.30143 58.5973L35.7457 47.9026C36.7948 47.5568 37.9362 48.1232 38.2952 49.1679L41.2186 57.6749Z",
    fill: "#EBEBEB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.9062,
    cy: 48.1338,
    rx: 34.0092,
    ry: 32.415,
    fill: "#EBEBEB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7519,
    cy: 37.6432,
    rx: 1.59418,
    ry: 2.12558,
    fill: "#9C9C9C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.2541,
    cy: 38.7057,
    rx: 1.59418,
    ry: 2.12558,
    fill: "#9C9C9C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.8096,
    cy: 53.4477,
    rx: 4.78254,
    ry: 6.90812,
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 83.2059C52.7805 89.956 47.3085 95.428 40.5585 95.428C33.8084 95.428 28.3364 89.956 28.3364 83.2059C28.3364 76.4559 33.8084 70.9839 40.5585 70.9839C47.3085 70.9839 52.7805 76.4559 52.7805 83.2059ZM36.0065 83.2059C36.0065 85.7199 38.0445 87.7579 40.5585 87.7579C43.0725 87.7579 45.1105 85.7199 45.1105 83.2059C45.1105 80.692 43.0725 78.654 40.5585 78.654C38.0445 78.654 36.0065 80.692 36.0065 83.2059Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4756 84.2689C81.4756 91.019 76.0036 96.491 69.2536 96.491C62.5035 96.491 57.0315 91.019 57.0315 84.2689C57.0315 77.5189 62.5035 72.0469 69.2536 72.0469C76.0036 72.0469 81.4756 77.5189 81.4756 84.2689ZM64.7016 84.2689C64.7016 86.7829 66.7396 88.8209 69.2536 88.8209C71.7675 88.8209 73.8055 86.7829 73.8055 84.2689C73.8055 81.7549 71.7675 79.717 69.2536 79.717C66.7396 79.717 64.7016 81.7549 64.7016 84.2689Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayUserLevel1);
export default __webpack_public_path__ + "static/media/grayUserLevel1.715533a9082cf95b9fc31f0b334b4dbe.svg";
export { ForwardRef as ReactComponent };